import { FT } from 'ft'
import { Sprite } from 'pixi.js'

const $hand = 'player-hand'

FT.rm.addImage($hand)

class PlayerHand extends Sprite {
  constructor() {
    super(FT.rm.texture($hand))
    this.anchor.set(0.5)
    this.position.set(FT.stage.centerX - 68, FT.stage.centerY + 2)
  }
}

export default PlayerHand
